import { Spin } from 'antd';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';

import { useSignDocument } from '@/features/contracts/api/use-sign-documents';

const SignPage = () => {
  const { contractId } = useParams();

  const { mutateAsync: getSignDocumentUrl, data: signDocumentUrl, isPending } = useSignDocument();

  useEffect(() => {
    getSignDocumentUrl({ documentId: Number(contractId) });

    const handleMessage = (event: MessageEvent) => {
      const eventData = event.data ? JSON.parse(event.data) : null;
      if (!eventData) {
        return;
      }

      if (eventData.action === 'onSignSuccess') {
        window.location.href = '/contracts';
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <div className="w-full mt-2 bg-white flex items-center justify-center pb-10 overflow-y-hidden h-full">
      {isPending ? (
        <Spin size="large" spinning={isPending} />
      ) : (
        <iframe id="isign-gateway" width="100%" height="100%" src={signDocumentUrl} title="iSign Gateway" />
      )}
    </div>
  );
};

export default SignPage;
